var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ArraySchema, MapSchema, Schema, type, view } from '@colyseus/schema';
import { GamePhase } from '../phases.js';
import { WinCondition } from '../roles.js';
import { VIEW_TAGS } from '../view-tags.js';
import { Player } from './Player.js';
import { RoomSettings } from './RoomSettings.js';
import { Vote } from './Vote.js';
export class GameState extends Schema {
    constructor() {
        super(...arguments);
        this.phase = GamePhase.Lobby;
        this.phaseEndsAt = 0;
        this.phaseDurationMs = 0;
        this.hostId = '';
        this.players = new MapSchema();
        this.votes = new MapSchema();
        this.settings = new RoomSettings();
        this.currentClueGiverId = '';
        this.firstClueGiverWasRandom = false;
        this.pendingEliminationId = '';
        this.consecutiveClueRoundsWithoutElimination = 0;
        this.ghostGuessText = '';
        this.ghostGuessCorrect = false;
        this.winCondition = WinCondition.None;
        this.revealedSecretWord = '';
        this.ghostIds = new ArraySchema();
        this.ghostMeetingVotes = new MapSchema();
    }
}
__decorate([
    type('string')
], GameState.prototype, "phase", void 0);
__decorate([
    type('number')
], GameState.prototype, "phaseEndsAt", void 0);
__decorate([
    type('number')
], GameState.prototype, "phaseDurationMs", void 0);
__decorate([
    type('string')
], GameState.prototype, "hostId", void 0);
__decorate([
    type({ map: Player })
], GameState.prototype, "players", void 0);
__decorate([
    type({ map: Vote })
], GameState.prototype, "votes", void 0);
__decorate([
    type(RoomSettings)
], GameState.prototype, "settings", void 0);
__decorate([
    type('string')
], GameState.prototype, "currentClueGiverId", void 0);
__decorate([
    type('boolean')
], GameState.prototype, "firstClueGiverWasRandom", void 0);
__decorate([
    type('string')
], GameState.prototype, "pendingEliminationId", void 0);
__decorate([
    type('number')
], GameState.prototype, "consecutiveClueRoundsWithoutElimination", void 0);
__decorate([
    type('string')
], GameState.prototype, "ghostGuessText", void 0);
__decorate([
    type('boolean')
], GameState.prototype, "ghostGuessCorrect", void 0);
__decorate([
    type('string')
], GameState.prototype, "winCondition", void 0);
__decorate([
    type('string')
], GameState.prototype, "revealedSecretWord", void 0);
__decorate([
    view(VIEW_TAGS.GHOSTS),
    type({ array: 'string' })
], GameState.prototype, "ghostIds", void 0);
__decorate([
    view(VIEW_TAGS.GHOSTS),
    type({ map: Vote })
], GameState.prototype, "ghostMeetingVotes", void 0);
//# sourceMappingURL=GameState.js.map